import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import { SectionHeaderWithCommand, SectionPaper } from '../../../../common/components';
import { CpsiUserIdEditor, CpsiCenterEditor, CpsiCopyPermissionsEditor } from '../fields/cpsiAccess';
import { EditorMode } from '../../../types/editorTypes';

interface CpsiAccessSectionProps {
  mode?: EditorMode;
}

/**
 * CpsiAccessSection - Section for CPSI access request fields
 * Shown when ticket/recurring task category is "CPSI Access"
 */
export const CpsiAccessSection: React.FC<CpsiAccessSectionProps> = ({ mode = 'ticket' }) => {
  const title = mode === 'recurringTask' ? 'CPSI Access Request Template' : 'CPSI Access Request';

  return (
    <Box>
      <SectionHeaderWithCommand
        icon={<LockOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title={title}
      />
      
      <SectionPaper>
        <Stack spacing={3}>
          {/* User Selection - Full Width */}
          <Box>
            <Typography 
              variant="body2" 
              sx={{ 
                mb: 1, 
                fontWeight: 500, 
                color: '#64748b' 
              }}
            >
              Select User
            </Typography>
            <CpsiUserIdEditor mode={mode} />
          </Box>
          
          {/* Center and Copy Permissions - Side by Side */}
          <Box>
            <Typography 
              variant="body2" 
              sx={{ 
                mb: 1, 
                fontWeight: 500, 
                color: '#64748b' 
              }}
            >
              Access Details
            </Typography>
            <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
              <Box sx={{ flex: 1 }}>
                <CpsiCenterEditor mode={mode} />
              </Box>
              <Box sx={{ flex: 1 }}>
                <CpsiCopyPermissionsEditor mode={mode} />
              </Box>
            </Stack>
          </Box>
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default CpsiAccessSection;
